import React from 'react'
import { cn } from './cn'
import { useCopyFeedback } from './use-copy-feedback.js'

export interface CopyFieldProps {
  /** The text shown and copied, e.g. a share link. */
  value: string
  copyLabel: string
  copiedLabel: string
  /** Performs the copy (each app has its own clipboard bridge); reject when it failed. */
  onCopy: (value: string) => Promise<void>
  className?: string
}

const COPIED_MS = 2000

/**
 * 一條唯讀的值（分享連結）加上接在右邊的「複製」按鈕，外框是一個整體。按了且複製成功，
 * 按鈕字換成「已複製」兩秒；複製失敗不假裝成功。
 */
export function CopyField({ value, copyLabel, copiedLabel, onCopy, className }: CopyFieldProps) {
  const { copied, copy } = useCopyFeedback(COPIED_MS)

  return (
    <div
      className={cn(
        'flex h-11 max-w-115 items-center gap-3 overflow-hidden rounded-[var(--radius)] border border-border pl-3.5',
        className
      )}
    >
      <span className="min-w-0 flex-1 truncate text-sm">{value}</span>
      <button
        type="button"
        onClick={() => void copy(() => onCopy(value))}
        className="h-full shrink-0 cursor-pointer border-0 border-l border-border bg-background px-4 text-sm font-medium text-foreground transition-colors hover:bg-[var(--fg-soft)] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--focus-ring)]"
      >
        {copied ? copiedLabel : copyLabel}
      </button>
    </div>
  )
}
